export default {
  header: '訂單及銷售管理',
  title: '訂單及銷售管理',
  agentInfo: {
    header: '顧問資料',
    agent: '顧問',
    agentSplitRate: '顧問分成',
    isActive: '活躍',
    isServiceAgent: '主要顧問',
    effectiveDate: '有效日期',
    expiryDate: '無效日期',
    totalSplitRate: '總比率 :',
    deleteAgentConfirm: '<h5>你確認刪除 <span class="text-danger">Delete</span> agent with contents below?</h5> <p>Agent English Name: {agentEnglishName}</p><p>Agent Chinese Name: {agentChineseName}</p>'
  },
  contents: {
    general: {
      agentRemarks: '顧問備註',
      renewal: "續保",
      page: '頁',
      total: '總數',
      items: '項目',
      life: '人壽',
      gi: '一般保險',
      detail: '內容',
      delete: '刪除',
      deleteSuccess: '成功刪除保單!',
      deletePolicyConfirm: '<h5>你要確認 <span class="text-danger">Delete</span> policy with contents below?</h5> <p>Policy Number: {policyNumber}</p><p>Policy Reference : {policyRef}</p>',
      attachment: '附件',
      actions: '行動',
      create: '新增',
      policyStatus: '保單狀態',
      workFlowStep: '流程步驟',
      updateTime: '最後更新時間',
      serviceRequest: { title: '服務申請' },
      outstandingRequirement: { title: '未完成的要求' },
      rejectedPolicy: '已被拒保單',
      completedPolicy: '已完成保單',
      rejectedPolicyModal: '<p>你已成功否決保單了。</p><p>此頁會被轉到 {type} Policy List.</p>',
      completedPolicyModal: '<p>你已完成保單了。</p><p>此頁會被轉到 {type} Policy List.</p>',
      addRiderConfirm: '你確認要加保單附件 {name} 於此保單 ?',
      removeRiderConfirm: '你確認要移除保單附件  {name} 由此保單 ?',
      changeBusiness: {
        title: 'Change Business',
        lapseDate: '保單失效日期',
        surrenderDate: '退保日期',
        reinstateDate: '復保日期',
        transferOut: '保單轉出',
        transferIn: '保單轉入',
        changePremiumType: '轉換續保期數',
        confirmActionContent: '<p><b>保單號碼:</b> {policyNumber}</p><p><b>保單持有人:</b> {policyOwner}</p>',
        confirmActionWarning: '<p>確認 {action} 此保單?</p>',
        transferInConfirm: '確認轉入此保單?',
        lapse: '失效',
        surrender: '退保',
        reinstate: '復保',
      }
    },
    lifePolicy: {
      header: '人壽保單',
      new: ' 新增人壽保單',
      generalInfo: '一般資料',
      general: '一般',
      internalUse: '只供內部使用',
      currentWorkflow: '流程',
      policyStatus: '狀態',
      policyType: '種類',
      payment: '付款',
      lifePolicy: '人壽保單',
      lifePolicyList: '人壽保單列表',
      lifeDetail: '內容',
      lifeOr: '未完成的要求',
      lifeTransferIn: '轉入',
      workflowCreate: '新增',
      workflowConfirm: '確認',
      workflowSentOut: '送出',
      workflowUnderwriting: '核保中',
      workflowInforce: '已生效',
      workflowReject: '否決',
      workflowCompanyReceive: '公司收到',
      workflowAgentReceive: '顧問收到',
      workflowCustomerReceive: '客戶收到',
      generalInformation: {
        policyAgent: '顧問',
        approveAgent: '顧問批準',
        policyStatus: '保單狀態',
        riders: {
          title: '附加條款',
          description: '描述',
          riderPremium: '附加條款保單',
          riderStatus: '附加條款狀態'
        },

        approveAgent: '審批者',
        paymentTerm: '供款年期',
        paymentMode: '付款方式',
        attachment: '附件',
        workFlowStep: '流程步驟',
        productName: '產品名稱',
        policyNumber: '保單號碼',
        policyReference: '參照保單',
        policyTerm: '保單年期',
        policyCurrency: '保單貨幣',
        premiumType: '保費期距',
        initialPremium: '初始保費',
        modalPremium: '每期保費',
        totalPremiums: '總保費',
        applicationDate: '申請日期',
        applicationReceivedDate: '收到申請日期',
        conditionalAssignmentFlag: 'Conditional Assignment Flag',
        originalAgent: '原有顧問',
        currentAgent: '現時顧問',
        originalReferrer: '推薦人',
        policyOwner: '保單持有人',
        insurer: '受保人',
        beneficiary: '受益人',
        thirdParty: '第三方',
        remarks: '備註',
        docs: '文件上載',
        paymentDate: '付款日期',
        paymentMethod: '付款方式',
        paymentAmount: '付款數目',
        sentOutDate: '送出日期',
        sentOutMedium: '送出媒介',
        sentOutReference: '送出參考數',
        companyBank: '公司銀行',
        paymentReference: '付款參照',
        commencementDate: '開始日期',
        issueDate: '簽發日期',
        welcomeLetterSentOutDate: '歡迎信送出日',
        companyReceiveDate: '公司收到日期',
        agentReceiveDate: '顧問收到日',
        customerReceiveDate: '官戶收到日',
        //
        levy: '政府徵費'
      }
    },
    giPolicy: {
      header: '一般保險單',
      new: '新增一般保險單',
      generalInfo: '一般資訊',
      policyInfo: '保單資料',
      general: '一般',
      fee: '費用',
      internalUse: '內部',
      commission: '佣金',
      payment: '付費',
      policyAgent: '顧問',
      currentWorkflow: '流程',
      policyStatus: '保單狀態',
      policyType: '類別',
      giPolicy: '一般保險單',
      giPolicyList: '一般保險單列表',
      giPolicyDetail: '內容',
      giOr: '未完成的要求',
      workflowCreate: '新增',
      workflowConfirm: '確認',
      workflowSentOut: '送出',
      workflowUnderwriting: '核保',
      workflowInforce: '生效',
      workflowReject: '否決',
      workflowCompanyReceive: '公司收到',
      workflowAgentReceive: '顧問收到',
      workflowCustomerReceive: '客戶收到',

      generalInformation: {
        policyAgent: '顧問',
        approveAgent: '審批顧問',
        attachment: '附件',
        actions: '行動',
        policyStatus: '保單狀態',
        workFlowStep: '流程步驟',
        updateTime: '上次更新時間',
        policyOwnerName: '保單持有人名稱',
        currentAgentName: '現時顧問名稱',
        productName: '產品名稱',
        policyNumber: '保單號碼',
        policyReference: '保單參考數',
        applicationDate: '申請日期',
        applicationReceiveDate: '申請收到日期',
        policyCurrency: '保單貨幣',
        policyType: '保單類別',
        modalPremium: '每期保費',
        premiumPaid: '已繳保單',
        premiumType: '保費期距',
        premiumTypeOptions: {
          annual: '年繳',
          halfYear: '半年繳',
          quater: '季繳',
          month: '月繳'
        },
        actuallyPaid: '已付',
        paymentMethod: '付款方式',
        paymentAmount: '付款金額',
        companyBank: '公司銀行',
        paymentReference: '付款參考數',
        paymentMethodOptions: {
          cheque: "支票",
          bankTransfer: "銀行轉帳",
          bankIn: "銀行入數"
        },
        docs: '文件上載',
        paymentDate: '付款日期',
        originalAgent: '原顧問',
        currentAgent: '現時顧問名',
        ownerCustomer: '保單持有人',
        policyFee: '保單費用',
        insuredCustomer: '受保客戶',
        agentCommissionRate: '顧問佣金率(%)',
        agentCommissionPaid: '顧問佣金率已付',
        newBusinessOrRenewal: '新生意或續保',
        newBusinessOrRenewalOptions: {
          newBusiness: '新生意',
          renewal: '續保',
          pleaseSelect: '--  請選擇保單類別 --'
        },
        levyOrMIB: '政府徵費 or 車保局',
        remarks: '備註',
        premiumPaid: '已付保費',
        insurerRebate: '保險公司回贈',
        chequeToInsurer: '給保險公司支票',
        chequeToInsurerNumber: '保險公司支票號碼',
        chequeIssueDate: '支票發出日',
        sentOutDate: '送出日期',
        sentOutMedium: '送出方式',
        sentOutReference: '送出參考數',
        sentOutMediumOptions: {
          email: '電郵',
          courier: '快遞',
        },
        courierNo: '快遞號碼',
        effectiveDate: '生效日期',
        expiryDate: '終結日期',
        issueDate: '簽發日期',
        companyReceiveDate: '公司收到日期',
        agentReceiveDate: '代理收到日期',
        customerReceiveDate: '客戶收到日期'
      },
      productInformation: {
        //Travel
        coverageType: '保障類別',
        packageType: '套票類別',
        travelType: '旅行類別',
        days: '日數',
        destination: '目的地',

        //contrator all risk
        contractSum: '合約總額',
        limitOfIndemnity: '賠款限額',
        nameOfInsured: '受保人名稱',
        nameOfPrincipal: '主要人名稱',
        natureOfBusiness: '業務性質',
        periodOfInsurance: '受保期間',
        riskLocation: '風險地點',
        typeOfCoverage: '保障範圍類別',

        //Domestic helper
        coverage: '受保範圍',
        insurancePeriod: '受保期間 (月)',
        nameOfEmployee: '僱主名稱',
        placesEmployed: '受僱地點',

        //employee comp
        employeeRiskRate: '僱員風險率',
        estAnnualSalary: '預計薪金',
        occupation: '職業',

        riskRate: '風險率',
        mortgagee: '房貸',

        //healthMedical
        optionalBenefits: '可選保障',
        relationship: '關係',
        typeOfHealth: '健康類別',
        typeOfPlan: '計劃類別',

        //home protection
        grossArea: '總面積',
        homeContent: '家居財物',
        propertyAge: '物業年齡',

        //motor
        bodyType: '車身類別',
        capacity: '車容量',
        chassisNumber: '車架編號',
        coverageType: '保障範圍類別',
        engineNumber: '引擊號碼',
        hirePurchaseOwner: '租購人',
        makeAndModel: '廠商及型號',
        namedDriver: '司機名稱',
        ncb: '免賠額',
        seatsExcDriver: '座位不包括司機',
        sumInsured: '保額',
        typeOfVehicle: '車輛類別',
        vehicleNumber: '車輛號碼',

        //office Package
        numberOfEmployee: '僱員名稱',
        officeContent: '辦公室財物',
        officeRiskRate: '辦公室風險率',
        title: '主題',

        //personal accident
        acciDeathNPermDisableAmt: '意外死亡及永久殘疾額',
        acciDeathNPermDisablePrem: '意外死亡及永久殘疾保費',
        acciMediExpPerAcciAmt: '每意外額的意外醫療費用',
        acciMediExpPerAcciPrem: '每意外保費的意外醫療費用',
        classOfOccupation: '職業類別',
        hosCashAllowPerDayAmt: '每日醫療現金',
        hosCashAllowPerDayPerm: '每日保費的醫療現金',
        incomeProtPerYrAmt: '每年收入保障額',
        incomeProtPerYrPerm: '每年收入保障/每年保額',

        //shop package
        stock: '存貨',
        stockRiskRate: '貨物風險率',

        //china medical card
        occupation: '職業',
        planCovered: '受保計劃',

        //machinery all risk
        insuredPremises: '受保資產',
        itemDescription: '項目描述',

        //property all risk
        riskLocation: '風險地點',

        //marine cargo
        nameOfAssured: '受保名稱',
        vesselName: '貨船名稱',
        voyage: '旅程',
        content: '財物',

        //group personal accident
        scopeOfCover: '保障範疇',
        aggrateLimit: '累計限額',
        totalHeadcount: '總人數',

        //product liability
        businessNature: '業務性質',
        productDescription: '產品描述',
        turnover: '生意顛'
      }
    }
  },

  serviceRequest: {
    original: '原有資料',
    new: '新資料',
    comparison: '比較',
    serviceType: '服務類別',
    comment: '意見',
    receiveTime: '收到時間',
    completeTime: '完成時間',
    approval: '審批',
    header: '服務請求',
    srList: '列表',
    approve: '通過',
    reject: '否決',
    select: {
      header: '選擇服務請求',
      type: '請求類別'
    },
    'workflow-1': '新增服務請求',
    'workflow-2': '更新服務請求狀態',
    agent: '搜尋顧問',
    customer: '搜尋客戶',
    policyType: '保單類別',
    status: '服務請求狀態',

    select: {
      header: '選擇服務請求',
      agent: '顧問',
      policyDetail: '保單資料',
      policyStatus: '保單狀態',
      policyValue: '保單價值',
    },

    confirm: {
      header: '確認',
      body: {
        approve: '確認要通過這個服務請求嗎',
        reject: '確認要否決這個服務請求嗎'
      }
    },

    type: {

      CPM: {
        header: '改變付款方法',
        paymentMethod: '付款方式',
        paymentReference: '付款參考號',
        companyBank: '公司銀行',
        paymentDate: '付款日期',
        paymentStartDate: '付款開始日期',
        paymentEndDate: '付款完結日期',
      },
      CAS: {
        header: 'Assignment',
        initialAgent: 'Initial Agent',
        currentAgent: 'Current Agent',
      },
      CBF: {
        header: '轉變受益人',
        beneficiary: '受益人'
      },
      CPO: {
        header: '改變付款方式',
        paymentMode: '付款方式'
      },
      CGA: {
        header: '改變保費額',
        modalPremium: '每期保費'
      },
      CPA: {
        header: '改變保費額',
        premiumAmount: '每期保費'
      },
      PLO: {
        header: '保單貸款',
        currentLoanAmount: '現時貸款額'
      },
      PSE: {
        header: '保單結算',
        currentLoanAmount: '現時貸款額'
      },
      PAU: {
        header: '清繳保費',
        policyPaidUpDate: '已清繳日期'
      },
      REI: {
        header: '復效保單'
      },
      SUR: {
        header: '退保',
        policyEndDate: '保單完結日期'
      },
      SUS: {
        header: 'Suspension'
      },
      WID: {
        header: '提款',
        totalWithdrawals: '總提款額'
      },
      CRI: {
        header: '改變附加條款',
        removeRider: '刪除附加條款',
        recoverRider: '回復附加條款',
        newRider: '新增附加條款',
        riderProduct: '附加條款產品',
        riderPremium: '附加條款保費'
      },
      CPB: {
        header: '改變保額',
        modalPremium: '每期保費'
      },
      HOL: {
        header: '改變保單假期'
      },
      TRO: {
        header: '轉出保單',
        policyEndDate: '保單完結日期'
      },
      GAS: {
        header: 'Assignment',
        currentAgent: 'Current Agent'
      },
      LAP: {
        header: '人壽保單失效',
        policyLapseDate: '保單失效日期'
      },
      GAP: {
        header: '一般保單失效',
        policyLapseDate: '保單失效日期'
      },
      DSA: {
        header: '基金轉換權力下放'
      },
      MTA: {
        header: '強積金資產轉換'
      },
      SRD: {
        header: '基金轉換及改變供款'
      },
    }
  },
  provider: {
    header: '保險公司',
    providerCode: '保險公司編號',
    edit: {
      header: '編輯',
    },
    delete: {
      header: '刪除',
      confirmDelete: '<h5>確認要 <span class="text-danger">刪除</span> 保險公司以下內容?</h5> <p>Provider Code: {providerCode}</p><p>Provider Chinese Name: {providerChineseName}</p><p>Provider English Name: {providerEnglishName}</p>'
    },
    create: {
      header: '新增保險公司',
      providerEnglishName: '保險公司英文名',
      providerChineseName: '保險公司中文名',
      providerDescription: '保險公司描述',
      providerCountry: '保險公司國家',
      splitRate: "分成比率(%)",
      splitRate2: "分成比率 2(%)",
    },
    list: {
      header: '保險公司名單',
      providerName: '保險公司名稱',
      updateTime: '最後更新'
    }
  },
  product: {
    header: '產品',
    create: {
      header: '新增產品',

    },
    list: {
      header: '產品名單',
      updateTime: '最後更新',
    },
    delete: {
      header: '刪除產品',
      confirmDelete: '<h5>確認要 <span class="text-danger">刪除</span> 以下的產品內容?</h5><table><tr><td><b>Product Code:</b></td><td>{productCode}</td></tr><tr><td><b>Product Chinese Name:</b></td> <td>{productChineseName}</td></tr><tr><td><b>Product English Name:</b></td><td>{productEnglishName}</td></tr><table>'
    },
    edit: {
      header: '編輯產品',
    },
    productName: '產品名稱',
    productCode: '產品編號',
    productCodeByIssuer: '保險公司提供的產品編號',
    productEnglishName: '產品英文名',
    productChineseName: '產品大文名',
    productType: '產品類別',
    remarks: '備註',
    status: '狀態',
    effectiveDateFrom: '有效期由',
    effectiveDateTo: '有效至',
    policyFeeHkd: '保單費用 (HKD)',
    policyFeeUsd: '保單費用 (USD)',
    allowCommissionRateOver100: '容許佣金高於 100%',
    commissionEffectiveFrom: '佣金有效期由',
    commissionEffectiveTo: '佣金有效期至',
    firstYearCommissionRate: '首年佣金率',
    year1Override: '首年下線抽成率（%)',
    year2Override: '次年下線抽成訊(%)',
    year1AnnualBonus: '首年年終獎金(%)',
    year2AnnualBonus: '次年年終獎金(%)',
    yearComm: '年 {年} 佣(%)',
    cutoffType: 'Cutoff Type',
  },
  renewal: {
    header: '績保',
    list: {
      modalPremium: '期間保費',
      nextPaymentDateFrom: '付款日期由',
      nextPaymentDateTo: '付款日期至',
      policyType: '保單類別',
      header: '續保紀錄列表',
      nextPaymentDate: '下次付款日期',
      showRecentOnly: '只顯示最近紀錄'
    },
    dueIn: '付款到期於',
    renew: '續保',
    renewLife: {
      header: '人壽續保',
      period: '期間',
      actualPaymentDate: '真實付款日期',

    },
  },
  claim: {
    header: '賠償',
    apply: '申請賠償',
    policyReference: '保單參考號',
    policyType: '保單類別',
    status: '狀態',
    agentName: '顧問名稱',
    claimType: '賠償類別',
    expectedClaimAmount: '預期賠償額',
    updateTime: '更新時間',
    agentCode: '顧問編號',
    claimRequestDate: '賠償申請日期',
    claimResponseDate: '賠償回覆日期',
    policy: '保單',
    remark: '備註',
    claimResult: '賠償結果',
    companyReceiveDate: '公司收到日期',
    agentReceiveDate: '顧問收到日期',
    customerReceiveDate: '客戶收到日期',
    claimIssueDate: '賠償簽發日期',
    claimPaymentMethod: '賠償付款方式',
    claimReference: '賠償參照號',
    claimAmount: '賠償額',
    detail: {
      header: '賠償內容'
    },
    list: {
      header: '賠償列表',
    },
    create: {
      header: '新增賠償',
      'workflow-1': '申請賠償',
      'workflow-2': '處理中',
      'workflow-3': '賠償內容',
      'workflow-4': '已完成賠償',
      confirmModal: '<h5>確認要 <b class="text-danger">{action}</b> 這個賠償?</h5>',
      claimResultModal: '<h5>確認要 <b class="text-danger">{action}</b> 這個賠償結果?</h5>',
      saveResult: '儲存',
      createResult: '新增',
    }
  }

}



// WEBPACK FOOTER //
// ./src/Osm/langs/zh_hk/index.js